import { EventType, SourcePages, ImpressionType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../../types';

export type UserExperience = 'local' | 'regional' | 'national';

interface QuickPicksEventInfo extends VehicleEventInfo {
  vin: string;
  vdpUserExperience: UserExperience;
  horizontalPosition: number;
  impressionType: 'result' | 'view';
  sourcePage: SourcePages;
}

const event = ({
  vin,
  trackingParams,
  vdpUserExperience,
  horizontalPosition,
  impressionType,
  sourcePage,
}: QuickPicksEventInfo): EventData => {
  const type =
    impressionType === 'result' ? ImpressionType.quickPicksResult : ImpressionType.quickPicksView;

  return {
    event_type: EventType.listingImpression,
    source_page: sourcePage,
    impression_type: type,
    type,
    vin,
    event_context: {
      horizontal_postition: horizontalPosition,
      tracking_params: trackingParams,
      vdp_user_experience: vdpUserExperience,
    },
  };
};

export default event;
